import { CriteriaBase } from '@/shared/models/CriteriaBase.model';

/**
 * Liste des filtres possible pour récupérer la liste des utilisateurs producteur.
 */
export class UtilisateurProducteurCriteria extends CriteriaBase {
    /**
     * Détermine si l'utilisateur est actif.
     */
    public estActif: boolean = true;

    /**
     * Le champ de recherche pour filtrer sur différentes propriétés de l'utilisateur (nom, prénom, fonction...).
     */
    public recherche: string | null = null;

    /**
     * Identifiant technique du rôle.
     */
    public roleId: string | null = null;
}
